// extracted by mini-css-extract-plugin
export var highlightFade = "_2i-4";
export var highlighted = "_2i-3";
export var table = "_2i-1";
export var tableContainer = "_2i-0";
export var totalsRow = "_2i-2";